import { useState, createContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AppBar } from './styling/StyledComponents';
import poweredByAcis from './images/PoweredbyACIS.png';
import ProductSelection from './ProductSelection';
import Windrose from './productComponents/Windrose';
import Bintemps from './productComponents/Bintemps';
import Monsmry from './productComponents/Monsmry';
import Monhrly from './productComponents/Monhrly';
import Gridmap from './productComponents/Gridmap';
import Exthrly from './productComponents/Exthrly';
import Conhrly from './productComponents/Conhrly';
import Listhrly from './productComponents/Listhrly';
import Meteogrf from './productComponents/Meteogrf';
import Occhrly from './productComponents/Occhrly';

export const StoredContext = createContext();

export default function App() {
	const [ drawerOpen, setDrawerOpen ] = useState(true);
	const [ storedParams, setStoredParams ] = useState({ sid:"", stnName:"", area:"ME,WV", areaType:"region" });

	const NoMatch = () => {
		return (
			<div style={{ margin: "80px 8px", color: "red"}}>
				<ArrowBackIcon sx={{ pt: 1 }}/>
				<span>Select a product from the list</span>
			</div>
		)
	}
		
	const toggleDrawer = () => {
		setDrawerOpen(!drawerOpen);
	};

	return (
		<>
			<Box sx={{ display: 'flex' }}>
				<AppBar position="absolute" open={drawerOpen}>
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							aria-label="drawerOpen drawer"
							onClick={toggleDrawer}
							sx={{
								marginRight: '36px',
								...(drawerOpen && { display: 'none' }),
							}}
						>
							<MenuIcon />
						</IconButton>
						<Typography
							component="h1"
							variant="h6"
							noWrap
							sx={{ flexGrow: 1 }}
						>
							ACIS New App Dashboard - BETA
						</Typography>
						<img src={poweredByAcis} style={{width: '20%'}} alt={'Powered by ACIS'} />
					</Toolbar>
				</AppBar>

				<ProductSelection
					drawerOpen = {drawerOpen}
					toggleDrawer = {toggleDrawer}
				/>

				<StoredContext.Provider value={{storedParams, setStoredParams}}>
					<Routes>
						<Route path="/windrose" element={<Windrose />} />
						<Route path="/bintemps" element={<Bintemps />} />
						<Route path="/monsmry"  element={<Monsmry />} />
						<Route path="/monhrly"  element={<Monhrly />} />
						<Route path="/exthrly"  element={<Exthrly />} />
						<Route path="/conhrly"  element={<Conhrly />} />
						<Route path="/listhrly" element={<Listhrly />} />
						<Route path="/meteogrf" element={<Meteogrf />} />
						<Route path="/occhrly"  element={<Occhrly />} />
						<Route path="/gridmap"  element={<Gridmap />} />
						<Route path="/*"        element={<NoMatch />} />
						<Route path="*"         element={<NoMatch />} />
					</Routes>
				</StoredContext.Provider>
			</Box>
		</>
	);
}